import {FAILURE, PENDING, SUCCESS, RESET, SET_DIRECTION, SET_DATES} from '../../constants'
import {useReducer} from 'react'
import moment from 'moment'
import _ from 'lodash'
import {eventsDataList} from '../../../state/reservation/events/reducer'

const ActionTypes = {FAILURE, PENDING, SUCCESS, RESET, SET_DIRECTION, SET_DATES}
const InitialState = {
  data: [],
  isLastFutureRecord: false,
  isLastPastRecord: false,
  startDate: moment(),
  endDate: moment().add(1, 'months'),
  prevEndDate: moment().subtract(1, 'months'),
  errors: null,
  isLoading: false,
  futureOffset: 1,
  pastOffset: 1,
  offset: 0,
  direction: '',
  limit: 50,
  total: 1,
}

const sortDates = arr => {
  if (arr.length === 0) return []
  return arr.sort((a, b) => {
    var dateA = new Date(a.start_date)
    var dateB = new Date(b.start_date)
    return dateA - dateB
  })
}

function Reducer(state = InitialState, action) {
  switch (action.type) {
    case ActionTypes.PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case ActionTypes.RESET:
      return {
        ...InitialState,
      }
    case ActionTypes.SET_DATES:
      return {
        ...state,
        [action.field]: action.value,
      }

    case ActionTypes.SET_DIRECTION:
      return {
        ...state,
        direction: action.value,
      }
    case ActionTypes.SUCCESS:
      const newState = {...state, viewData: action.payload.viewData}
      const payload = {...action.payload, view_data: action.payload.viewData}
      const {_data} = eventsDataList(newState, {payload})
      const orderedEvents = _data

      return {
        ...state,
        isLoading: false,
        errors: null,
        data: orderedEvents,
        isLastFutureRecord:
          state.isLastFutureRecord ||
          (state.direction === 'future' && action.payload.events.length < 55),
        isLastPastRecord:
          state.isLastPastRecord ||
          (state.direction === 'past' && action.payload.events.length < 55),
        futureOffset: state.direction === 'future' ? state.futureOffset + 1 : state.futureOffset,
        pastOffset: state.direction === 'past' ? state.pastOffset + 1 : state.pastOffset,
        offset: state.direction === 'future' ? state.futureOffset : state.pastOffset,
        limit: 50,
        total: action.payload.events.length > 0 ? orderedEvents.length + 1 : orderedEvents.length,
      }
    case ActionTypes.FAILURE:
      return {
        ...state,
        offset: 0,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}
const useCalendarSearchReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useCalendarSearchReducer
export {ActionTypes, InitialState, Reducer}
